<template>
	<section v-if="false !== race && false !== status" class="min-h-full">
		<header class="md:flex md:items-center md:justify-between ">
			<div class="sm:flex items-center sm:space-x-5">
				<div class="-mb-1">
					<div v-if="participant_status !== 'undefined' && participant_status !== null" class="w-full mb-3">
						<span class="pill" :class="participant_status.toLowerCase()">
							{{ participant_status }}
						</span>
					</div>

					<div class="sm:flex items-center mb-1">
						<h1 class="text-4xl font-bold text-mono-lightest mb-2" v-html="race.name"></h1>
					</div>

					<div class="flex items-center mt-1" v-if="null !== race.starts_at">
						<CalendarIcon class="flex-shrink-0 mr-2 h-4 w-4 sm:h-6 sm:w-6 text-mono-mid" /> 

						<div class="flex items-center">
							<time class="text-sm sm:text-md font-light text-mono-mid">{{ $functions.formatDate( race.starts_at ) }}</time> <span class="px-2">&mdash;</span> <time class="text-sm sm:text-md font-light text-mono-mid">{{ $functions.formatDate( race.ends_at ) }}</time>
						</div>
					</div>
				</div>
			</div>
		</header>

		<section class="py-12">
			<div class="lg:hidden">
				<label for="tabs" class="sr-only">Select a tab</label>

				<select @change="select_tab( $event )" id="tabs" name="tabs" class="text-mono-darkest block w-full focus:ring-advntm-accent focus:border-border-mono-darkest border-mono-darker">
					<option v-show="tab_is_enabled( tab )" :value="tab.id" v-for="tab in tabs" :key="tab.name" :selected="active_tab === tab.id">{{ tab.name }}</option>
				</select>
			</div>
			<div class="hidden lg:block">
				<nav class="flex space-x-4" aria-label="Tabs">
					<div class="relative" v-for="tab in tabs" :key="tab.name">
						<div class="pill new-pill text-mono-darkest" v-if="(typeof tab.new_tab !== 'undefined' && true === tab.new_tab) && active_tab !== tab.id">
							New!
						</div>

						<button @click.prevent="select_tab_via_button( tab )" v-show="tab_is_enabled( tab )" :class="[active_tab === tab.id ? 'bg-mono-darker text-mono-lightest' : 'text-mono-dark hover:text-advntm-highlight', 'p-3 font-medium text-sm']" :aria-current="tab.current ? 'page' : undefined" class="h-auto">
							{{ tab.name }}
						</button>
					</div>
				</nav>
			</div>
		</section>

		<section v-if="active_tab === 'information'" class="">
			<div class="pb-7">
				<h2 id="applicant-information-title" class="text-lg leading-6 font-medium text-mono-lighter">Race information</h2>
			</div>
			<div class="border-t border-mono-darker pt-7">
				<dl class="grid grid-cols-2 gap-x-4 gap-y-8 sm:grid-cols-3 items-center">
					<div v-if="null !== race.location && typeof race.location !== 'undefined'" class="race-detail">
						<dt class="text-sm font-medium text-mono-dark mb-2">
							Location
						</dt>
						<dd class="mt-1 text-md text-mono-lightest flex items-center">
							<LocationMarkerIcon class="flex-shrink-0 mr-2 h-6 w-6" aria-hidden="true" />
							<span class="leading-normal">{{ race.location }}</span>
						</dd>
					</div>

					<div v-if="null !== race.country && typeof race.country !== 'undefined'" class="race-detail">
						<dt class="text-sm font-medium text-mono-dark mb-2">
							Country
						</dt>
						<dd class="mt-1 text-md text-mono-lightest flex items-center">
							<FlagIcon class="flex-shrink-0 mr-2 h-6 w-6" aria-hidden="true" />
							<span class="leading-normal">{{ race.country }}</span>
						</dd>
					</div>
					<div v-if="null !== race.distance_miles && typeof race.distance_miles !== 'undefined'" class="race-detail">
						<dt class="text-sm font-medium text-mono-dark mb-2">
							Distance
						</dt>
						<dd class="mt-1 text-md text-mono-lightest flex items-center">
							<MapIcon class="flex-shrink-0 mr-2 h-6 w-6" aria-hidden="true" />
							<span class="leading-normal">{{ race.distance_miles }} miles</span>
						</dd>
					</div>
					<div v-if="null !== race.temperature && typeof race.temperature !== 'undefined'" class="race-detail">
						<dt class="text-sm font-medium text-mono-dark mb-2">
							Temperature
						</dt>
						<dd class="mt-1 text-md text-mono-lightest flex items-center">
							<SunIcon class="flex-shrink-0 mr-2 h-6 w-6" aria-hidden="true" />
							<span class="leading-normal">{{ race.temperature }}&deg;</span>
						</dd>
					</div>
					<div v-if="null !== race.terrain && typeof race.terrain !== 'undefined'" class="race-detail">
						<dt class="text-sm font-medium text-mono-dark mb-2">
							Terrain
						</dt>
						<dd class="mt-1 text-md text-mono-lightest flex items-center">
							<GlobeIcon class="flex-shrink-0 mr-2 h-6 w-6" aria-hidden="true" />
							<span class="leading-normal">{{ race.terrain }}</span>
						</dd>
					</div>
					<div v-if="false !== series" class="race-detail">
						<dt class="text-sm font-medium text-mono-dark mb-2">
							Series
						</dt>
						<dd class="mt-1 text-md text-mono-lightest flex items-center">
							<FolderOpenIcon class="flex-shrink-0 mr-2 h-6 w-6" aria-hidden="true" />
							<span class="leading-normal">{{ series.name }}</span>
						</dd>
					</div>
					<div v-if="null !== race.description && typeof race.description !== 'undefined'" class="col-span-full mt-6">
						<dt class="text-sm font-medium text-mono-dark mb-2">
							Description
						</dt>
						<dd class="mt-1 text-sm text-mono-lighter">
							<p class="text-sm font-light text-mono-light mb-0" v-html="race.description"></p>
						</dd>
					</div>
				</dl>

				<div class="race-detail mt-9 pt-9 border-t border-mono-darker">
					<div class="text-sm font-medium text-mono-mid mb-2">
						T-Shirt details
					</div>
					<div class="mt-1 text-md text-mono-lightest flex flex-wrap gap-9 items-center">
						<div class="space-y-3 ">
							<label for="doctor_contact_name" class="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2">
								T-shirt size <span class="-ml-0.5 text-state-danger">* <span class="hidden sr-only" aria-label="Required field">Required field</span></span>
							</label>
							<div class="mt-1 sm:mt-0 sm:col-span-2 text-mono-darker">
								<Select @change="update_tee_details" label="t_shirt_size" :options="t_shirt_sizes" v-model="t_shirt_size" :value="t_shirt_size" />
							</div>
						</div>

						<div class="space-y-6 sm:space-y-5 ">
							<label for="doctor_contact_name" class="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2">
								T-shirt style fit <span class="-ml-0.5 text-state-danger">* <span class="hidden sr-only" aria-label="Required field">Required field</span></span>
							</label>
							<div class="mt-1 sm:mt-0 sm:col-span-2 text-mono-darker">

								<Select @change="update_tee_details" label="t_shirt_style_of_fit" :options="t_shirt_fits" v-model="t_shirt_style_of_fit" :value="t_shirt_style_of_fit" />
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>

		<section v-if="active_tab === 'waiting_list' && true === is_in_waiting_list" class="">
			<div class="pb-7">
				<h2 id="to_do_list-title" class="text-lg leading-6 font-medium text-mono-lighter">Waiting List</h2>
			</div>

			<div>
				<div class="flex items-center border-t border-b border-mono-darker py-7 mb-7">
					<ExclamationIcon class="mt-0.25 w-8 h-8 text-state-danger mr-3" />

					<p>You are in the waiting list. When a place becomes available, you will be contacted via <a :href="'mailto:' + $store.getters.user.email" v-html="$store.getters.user.email"></a>.</p>
				</div>

				<div class="waiting-list-position">
					<h3 class="text-lg leading-6 font-medium text-mono-lighter">Your position</h3>

					<table class="mt-7" v-if="Object.values( waiting_list ).length > 0">
						<thead class="border-b border-mono-darker">
							<tr>
								<th class="text-mono-dark font-medium text-sm pb-4">Position</th>
								<th class="text-mono-dark font-medium text-sm pb-4">Name</th>
								<th class="text-mono-dark font-medium text-sm pb-4">Nationality</th>
							</tr>
						</thead>

						<tbody>
							<tr v-for="competitor in waiting_list" :key="competitor.id">
								<td v-html="competitor.position"></td>
								<td v-if="competitor.id === $store.getters.user.id" v-html="competitor.first_name + ' ' + competitor.last_name"></td>
								<td v-else><div class="redacted"></div></td>
								<td v-if="competitor.id === $store.getters.user.id" ><img class="w-10" :src="'https://admin.advntm.com/flags/' + competitor.nationality + '.svg'" role="presentation"></td>
								<td v-else><div class="redacted"></div></td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</section>

		<section v-if="active_tab === 'to_do_list'" class="">
			<div class="pb-7">
				<h2 id="to_do_list-title" class="text-lg leading-6 font-medium text-mono-lighter">To do list</h2>
			</div>

			<Loader v-if="true === get_tab( 'to_do_list' ).loading" text="Loading your to do list" /> 

			<div v-if="typeof journey.steps !== 'undefined' && Object.values( journey ).length > 0">
				<Checklist class="border-t border-b border-mono-darker" v-on:input_checked="input_checked" :items="journey.steps" attr="step" />
			</div>

			<div v-else>
				<p v-if="true !== get_tab( 'to_do_list' ).loading" v-html="get_tab( 'to_do_list' ).emptyLabel"></p>
			</div>
		</section>

		<section v-if="active_tab === 'payments'" class="">
			<div class="pb-7">
				<h2 id="payments-title" class="text-lg leading-6 font-medium text-mono-lighter">Payments</h2>
			</div>

			<Loader v-if="true === get_tab( 'payments' ).loading" text="Loading your payment schedule" /> 

			<div v-if="Object.values( schedule ).length > 0">
				<div class="border-t border-mono-darker py-9">
					<Schedule :schedule="schedule" />
				</div>
			</div>

			<div v-else>
				<p v-if="true !== get_tab( 'payments' ).loading" v-html="get_tab( 'payments' ).emptyLabel"></p>
			</div>
		</section>

		<section v-if="active_tab === 'fundraising'" class="">
			<div class="pb-7">
				<h2 id="fundraising-title" class="text-lg leading-6 font-medium text-mono-lighter">Fundraising</h2>
			</div>

			<Loader v-if="true === get_tab( 'fundraising' ).loading" text="Loading fundraising information" /> 

			<div v-if="Object.values(fundraising).length > 0">
				<div class="border-t border-mono-darker py-9">
					<div v-if="fundraising.fundraising_platform">
						<img class="fundraising-platform" :src="require('@/assets/images/png/' + fundraising.fundraising_platform + '.png')" role="presentation">
					</div>

					<dl>
						<dd class="mt-1 text-sm text-mono-lighter">
							<ul role="list" class="border border-mono-darker rounded-md divide-y divide-mono-darker">
								<li v-if="typeof fundraising.fundraising_page_login_url !== 'undefined'" class="pl-3 pr-4 py-3 flex items-center justify-between text-sm">
									<div class="w-0 flex-1 flex items-center">
										<PaperClipIcon class="flex-shrink-0 h-5 w-5 text-mono-dark" aria-hidden="true" />
										<span class="ml-2 flex-1 w-0 truncate text-lg font-medium">Login to the fundraising page</span>
									</div>

									<div class="ml-4 flex-shrink-0">
										<div>
											<a target="_blank" :href="fundraising.fundraising_page_login_url" class="font-medium text-advntm-accent hover:text-advntm-highlight">
												<span>Login</span>
											</a>
										</div>
									</div>
								</li>

								<li v-if="typeof fundraising.fundraising_page_setup_url !== 'undefined'" class="pl-3 pr-4 py-3 flex items-center justify-between text-sm">
									<div class="w-0 flex-1 flex items-center">
										<PaperClipIcon class="flex-shrink-0 h-5 w-5 text-mono-dark" aria-hidden="true" />
										<span class="ml-2 flex-1 w-0 truncate text-lg font-medium">Set up or manage a Fundraising page</span>
									</div>

									<div class="ml-4 flex-shrink-0">
										<div>
											<a target="_blank" :href="fundraising.fundraising_page_setup_url" class="font-medium text-advntm-accent hover:text-advntm-highlight">
												<span>Manage</span>
											</a>
										</div>
									</div>
								</li>
							</ul>
						</dd>
					</dl>
				</div>
			</div>

			<div v-else>
				<p v-if="true !== get_tab( 'fundraising' ).loading" v-html="get_tab( 'fundraising' ).emptyLabel"></p>
			</div>
		</section>

		<section v-if="active_tab === 'race_pack'" class="">
			<div class="pb-7">
				<h2 id="race_pack-title" class="text-lg leading-6 font-medium text-mono-lighter">Downloads</h2>
			</div>

			<Loader v-if="true === get_tab( 'race_pack' ).loading" text="Loading your downloads" /> 

			<div v-if="Object.values( packs ).length > 0" class="border-t border-b border-mono-darker">
				<dl v-if="Object.values( packs ).length > 0" class="mt-9 pb-9">
					<dd class="mt-1 text-sm text-mono-lighter">
						<ul role="list" class="border border-mono-darker rounded-md divide-y divide-mono-darker">
							<li v-for="pack in packs" :key="pack.id" class="pl-3 pr-4 py-3 flex items-center justify-between text-sm">
								<div class="w-0 flex-1 flex items-center">
									<PaperClipIcon class="flex-shrink-0 h-5 w-5 text-mono-dark" aria-hidden="true" />
									<span class="ml-2 flex-1 w-0 truncate text-lg font-medium">{{ pack.description }}</span>
								</div>

								<div class="ml-4 flex-shrink-0">
									<div v-if="$functions.isMobile()">
										<a target="_blank" :href="pack.asset_file_url" class="font-medium text-advntm-accent hover:text-advntm-highlight">
											<span v-if="'URL' === pack.type">Open URL &rarr;</span>
											<span v-else>Download</span>
										</a>
									</div>
									<div v-else>
										<a target="_blank" :href="pack.asset_file_url" download class="font-medium text-advntm-accent hover:text-advntm-highlight">
											<span v-if="'URL' === pack.type">Open URL &rarr;</span>
											<span v-else>Download</span>
										</a>
									</div>
								</div>
							</li>
						</ul>
					</dd>
				</dl>
			</div>

			<div v-else>
				<p v-if="true !== get_tab( 'race_pack' ).loading" v-html="get_tab( 'race_pack' ).emptyLabel"></p>
			</div>
		</section>

		<section v-if="active_tab === 'upsell_products'" class="">
			<div class="pb-7">
				<h2 id="upsell_products-title" class="text-lg leading-6 font-medium text-mono-lighter">Products</h2>
			</div>

			<Loader v-if="true === get_tab( 'upsell_products' ).loading" text="Loading extras" /> 

			<div v-if="Object.values( upsell_products ).length > 0" class="border-t border-b border-mono-darker">
				<ul role="list" class="mt-9 mb-9 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
					<li v-for="product in upsell_products" :key="product.id" class="">
						<article class="rounded-lg upsell p-4 text-mono-darkest">
							<div>
								<div v-if="product.imageUrl" class="upsell-img_wrapper">
									<a target="_blank" :href="product.productUrl">
										<img class="mb-6 upsell-img border border-mono-mid rounded-md overflow-hidden" :src="product.imageUrl">
									</a>
								</div>
								
								<div v-if="product.productType" class="pill">
									{{product.productType}}
								</div>

								<h2 class="block text-lg font-medium">
									<a target="_blank" :href="product.productUrl" class="text-mono-darkest">
										{{product.title}}
									</a>
								</h2>
							</div>

							<div class="pt-5 mt-auto">
								<div class="grid grid-cols-2 sm:grid-cols-1 md:grid-cols-2 items-center">
									<div v-if="product.price">
										<p class="font-bold text-xl">
											&pound;{{product.price}}
										</p>
									</div>

									<div class="text-right sm:text-left md:text-right sm:mt-3 md:mt-0">
										<a class="bg-advntm-accent text-sm upsell-btn rounded-lg px-3 py-2 hover:bg-advntm-highlight hover:text-mono-darkest" target="_blank" :href="product.productUrl">
											View product
										</a>
									</div>
								</div>
							</div>
						</article>
					</li>
				</ul>
			</div>

			<div v-else>
				<p v-if="true !== get_tab( 'upsell_products' ).loading" v-html="get_tab( 'upsell_products' ).emptyLabel"></p>
			</div>
		</section>

		<section v-if="active_tab === 'questionnaires'" class="">
			<div class="pb-7">
				<h2 id="questionnaires-title" class="text-lg leading-6 font-medium text-mono-lighter">Questionnaires</h2>
			</div>

			<Loader v-if="true === get_tab( 'questionnaires' ).loading" text="Loading your questionnaires" /> 

			<div v-else> 
				<div v-if="true === get_tab( 'questionnaires' ).empty">
					<p v-html="get_tab( 'questionnaires' ).emptyLabel"></p>
				</div>

				<div v-else>
					<Questionnaire class="mb-5 pb-5 border-b border-mono-darker" :data="questionnaire" v-for="questionnaire in Object.values( questionnaires )" :key="questionnaire.id" />
				</div>
			</div>
		</section>

		<section v-if="active_tab === 'withdrawal'" class="">
			<div class="pb-7">
				<h2 id="withdrawal-title" class="text-lg leading-6 font-medium text-mono-lighter">Request a withdrawal</h2>
			</div>

			<div class="withdrawal border-t border-mono-darker pt-5">
				<p class="text-sm font-light text-mono-light mb-6">If you wish to withdraw from your chosen race, you can do so here. Once you withdraw, your request will be manually reviewed by our team and all eligible refund monies will be deposited into your  account. </p>

				<p>View our <a target="_blank" :href="$functions.getSiteData( 'domain', 'main' ) + '/terms-conditions/' + $functions.sanitize( race.name )">Terms &amp; Conditions</a>.</p>

				<div class="withdrawal-action mt-9">
					<Button @click.prevent="this.active_alert = 'withdrawFromRace'" text="Withdraw" />
				</div>

				<Alert :is_open="true === is_active_alert( 'withdrawFromRace' )" id="withdrawFromRace" title="Request a withdrawal" confirm="Withdraw" :description="'Are you sure you want to withdraw from ' + race.name + '?'" v-on:alert_dismissed="alert_dismissed" />
			</div>
		</section>
	</section>
</template>

<script>
	import { PaperClipIcon, SunIcon, GlobeIcon, MapIcon, CalendarIcon, LocationMarkerIcon, FlagIcon, FolderOpenIcon, ExclamationIcon } from '@heroicons/vue/outline';
	import t_shirt_sizes from '@/assets/json/t_shirt_sizes.json';
	import t_shirt_fits from '@/assets/json/t_shirt_fits.json';

	// how many waiting list places to show around the user's own position.
	const WAITING_LIST_WINDOW = 5;

	export default {
		components: {
			PaperClipIcon,
			CalendarIcon,
			SunIcon,
			GlobeIcon,
			FlagIcon,
			MapIcon,
			LocationMarkerIcon,
			FolderOpenIcon,
			ExclamationIcon
		},

		watch: {
			'active_tab': function( id ) {
				let tab = this.get_tab( id );

				if ( typeof tab !== 'undefined' ) {
					this.load_tab( tab );
				}
			}
		},

		computed: {
			race_url: function() {
				return 'competitor-portal/race/' + this.$route.params.id;
			}
		},

		data() {
			return {
				race: [],
				t_shirt_sizes: t_shirt_sizes,
				t_shirt_fits: t_shirt_fits,
				t_shirt_size: undefined,
				t_shirt_style_of_fit: undefined,
				series: false,
				journey: false,
				schedule: false,
				fundraising: false,
				active_alert: false,
				packs: false,
				upsell_products: false,
				waiting_list: false,
				status: false,
				participant_status: null,
				is_in_waiting_list: false,
				questionnaires: {},
				active_tab: 'information',
				user: false,
				tabs: [
					{ 
						name: 'Information', 
						id: 'information', 
						waiting_list: true, 
						show_if_status_is_minified: true, 
						hide_if_waiting_list_is_empty: false, 
						empty: false, 
						emptyLabel: false, 
						endpoint: null, 
						loading: false 
					},
					{ name: 'Questionnaires',
						id: 'questionnaires',
						waiting_list: false,
						show_if_status_is_minified: false,
						hide_if_waiting_list_is_empty: false,
						empty: false,
						emptyLabel: "There are no questionnaires to be completed yet.",
						endpoint: [ 'questionnaire/Vetting',
						'questionnaire/Medical' ],
						key: 'questionnaires',
						loading: false
					},
					{ name: 'Waiting List',
						id: 'waiting_list',
						waiting_list: true,
						show_if_status_is_minified: false,
						hide_if_waiting_list_is_empty: true,
						empty: false,
						emptyLabel: false,
						endpoint: null,
						loading: false
					},
					{ name: 'To do list',
						id: 'to_do_list',
						waiting_list: false,
						show_if_status_is_minified: false,
						hide_if_waiting_list_is_empty: false,
						empty: false,
						emptyLabel: "There are no live to do lists for this race currently.",
						endpoint: 'participant-journey',
						key: 'journey',
						loading: false
					},
					{ name: 'Payments',
						id: 'payments',
						waiting_list: false,
						show_if_status_is_minified: false,
						hide_if_waiting_list_is_empty: false,
						empty: false,
						emptyLabel: "The payment schedule for this race has not yet been confirmed.",
						endpoint: 'payments',
						key: 'schedule',
						loading: false
					},
					{ name: 'Fundraising',
						id: 'fundraising',
						waiting_list: false,
						show_if_status_is_minified: false,
						hide_if_waiting_list_is_empty: false,
						empty: false,
						emptyLabel: "This race doesn't have a fundraising option.",
						endpoint: 'fundraising-page-urls?raceId=' + this.$route.params.id,
						key: 'fundraising',
						loading: false
					},
					{ name: 'Downloads',
						id: 'race_pack',
						waiting_list: false,
						show_if_status_is_minified: false,
						hide_if_waiting_list_is_empty: false,
						empty: false,
						emptyLabel: "No race Downloads are available yet. Check back soon.",
						endpoint: 'race-pack',
						key: 'packs',
						loading: false
					},
					{ name: 'Products',
						id: 'upsell_products',
						waiting_list: false,
						show_if_status_is_minified: false,
						hide_if_waiting_list_is_empty: false,
						empty: false,
						emptyLabel: "There are no extras available for this race yet.",
						endpoint: null,
						loader: 'load_upsell_products',
						key: 'upsell_products',
						loading: false,
						new_tab: true
					},
					{ name: 'Withdrawal',
						id: 'withdrawal',
						waiting_list: false,
						show_if_status_is_minified: false,
						hide_if_waiting_list_is_empty: false,
						empty: false,
						emptyLabel: false,
						endpoint: false,
						key: 'withdrawal',
						loading: false
					},
				]
			}
		},

		async mounted() {
			if ( true !== this.$functions.isUserLoggedIn() ) {
				return;
			}

			// the user's profile only feeds the t-shirt form, so it doesn't block the view.
			this.fetch_user();

			let race = await this.fetch_race();

			console.log(race?.event.id);

			if ( null === race ) {
				return;
			}

			if ( ! race.has_fundraising_event ) {
				this.remove_tab( 'fundraising' );
			}

			this.status = 'proceed';

			// may downgrade the status to 'minified' once it resolves.
			this.fetch_participant_status();

			// the view is only revealed once we know where the user sits in the waiting list.
			if ( true === await this.fetch_waiting_list() ) {
				this.race = race;
				this.$emit( 'view_loaded', true );
			}
		},

		methods: {
			handle_request_error: function( error, text ) {
				if ( typeof error.response !== 'undefined' && 401 === error.response.status ) {
					this.$functions.handleUnauthorised();
				}

				if ( typeof text !== 'undefined' ) {
					this.$store.commit( 'message', { type: 401, text: text } );
				}
			},

			fetch_user: function() {
				return this.axios.get( 'competitor-portal/user' )
				.then( response => {
					this.user = response.data.data;
					this.t_shirt_size = this.user.t_shirt_size;
					this.t_shirt_style_of_fit = this.user.t_shirt_style_of_fit;
				} )
				.catch( error => {
					this.handle_request_error( error, 'Sorry, there has been a problem fetching your profile.' );
					this.$emit( 'view_loaded', null );
				} );
			},

			// resolves with the race, or null if it couldn't be fetched.
			fetch_race: function() {
				return this.axios.get( 'race/' + this.$route.params.id )
				.then( response => response.data.data )
				.catch( error => {
					this.handle_request_error( error, 'Sorry, there has been a problem fetching this race.' );
					this.$emit( 'view_loaded', null );

					return null;
				} );
			},

			fetch_participant_status: function() {
				return this.axios.get( this.race_url + '/status' )
				.then( response => {
					this.participant_status = response.data;

					if ( 'Withdrawn' === this.participant_status ) {
						// this.status = 'minified';
					}
				} )
				.catch( error => {
					this.handle_request_error( error, 'Sorry, there has been a problem checking your status on this race.' );
					this.$emit( 'view_loaded', null );
					this.waiting_list = false;
				} );
			},

			// resolves true if the waiting list was fetched, false otherwise.
			fetch_waiting_list: function() {
				return this.axios.get( this.race_url + '/waiting-list' )
				.then( response => {
					let competitors = Object.values( response.data.data );
					let user_index = competitors.findIndex( competitor => competitor.id === this.$store.getters.user.id );

					if ( -1 !== user_index ) {
						competitors.forEach( ( competitor, index ) => competitor.position = index + 1 );

						this.waiting_list = this.get_waiting_list_window( competitors, user_index );
						this.is_in_waiting_list = true;
					}

					return true;
				} )
				.catch( error => {
					this.handle_request_error( error, 'Sorry, there has been a problem checking your waiting list place on this race.' );
					this.$emit( 'view_loaded', null );
					this.waiting_list = false;

					return false;
				} );
			},

			// the user's place, plus up to two places either side of it.
			get_waiting_list_window: function( competitors, user_index ) {
				let start = Math.max( 0, user_index - 2 );

				return competitors.slice( start, start + WAITING_LIST_WINDOW );
			},

			update_tee_details: function() {
				this.$store.commit( 'message', [] );

				if ( typeof this.t_shirt_size !== 'undefined' ) {
					this.user.t_shirt_size = this.t_shirt_size;
				}

				if ( typeof this.t_shirt_style_of_fit !== 'undefined' ) {
					this.user.t_shirt_style_of_fit = this.t_shirt_style_of_fit;
				}

				this.axios.put( 'competitor-portal/user', this.user )
				.then( () => {
					this.$store.commit( 'message', { type: 200, text: 'Your updates were successfully saved.' } );
				} )
				.catch( error => {
					this.handle_request_error( error, 'Sorry, there has been a problem saving your updates.' );
				} );
			},

			tab_is_enabled: function( tab ) {
				if ( typeof this.status === 'undefined' ) {
					return false;
				}

				// if the status is minified, and the tab is set to be shown if status is minified.
				if ( ( this.status === 'minified' && true === tab.show_if_status_is_minified ) ) {
					return true;
				}

				// if the user is in the waiting list, and the tab is set to be shown for waiting list people, but the user is withdrawn, and should only see minified, they should be able to see waiting list stuff, so set to true.
				if ( ( this.status === 'minified' && false === tab.show_if_status_is_minified ) && ( true === this.is_in_waiting_list && true === tab.waiting_list ) ) {
					return true;	
				}

				// if the status is minified, and the tab is set to NOT show if status is minified.
				if ( ( this.status === 'minified' && false === tab.show_if_status_is_minified ) ) {
					return false;
				}

				// if the user is in the waiting list, and the tab is set to be shown for waiting list people.
				if ( ( true === this.is_in_waiting_list && true === tab.waiting_list ) ) {
					return true;	
				}

				// if the waiting list is empty, and the tab is set to be hidden if the waiting list is empty.
				if ( ( Object.values( this.waiting_list ).length === 0 && false === tab.hide_if_waiting_list_is_empty ) ) {
					return true;
				}

				// all other circumstances, proceed false.
				return false;
			},

			get_tab: function( id ) {
				return this.tabs.find( tab => id === tab.id );
			},

			remove_tab: function( id ) {
				this.tabs = this.tabs.filter( tab => id !== tab.id );
			},

			load_tab: function( tab ) {
				// tabs without an endpoint or loader render from data we already have.
				if ( ! tab.endpoint && ! tab.loader ) {
					return;
				}

				tab.empty = false;
				tab.loading = true;

				this.get_tab_request( tab ).finally( () => {
					tab.loading = false;
				} );
			},

			// tabs with a loader fetch from outside race_url, so they name their own method.
			get_tab_request: function( tab ) {
				if ( tab.loader ) {
					return this[ tab.loader ]( tab );
				}

				return Array.isArray( tab.endpoint )
					? this.load_tab_sections( tab )
					: this.load_tab_data( tab );
			},

			// tabs with several endpoints store each response under the last segment of its url, e.g. questionnaires.Medical.
			load_tab_sections: function( tab ) {
				let sections = this[ tab.key ];

				let requests = tab.endpoint.map( url => {
					let section = url.split( '/' ).pop();

					if ( typeof sections[ section ] !== 'undefined' ) {
						return Promise.resolve();
					}

					return this.axios.get( this.race_url + '/' + url )
					.then( response => {
						sections[ section ] = response.data.data;
					} )
					.catch( () => {} );
				} );

				return Promise.all( requests )
				.then( () => {
					tab.empty = Object.keys( sections ).length === 0;
				} );
			},

			load_tab_data: function( tab ) {
				// already fetched, nothing to do.
				if ( false !== this[ tab.key ] && typeof this[ tab.key ] !== 'undefined' ) {
					return Promise.resolve();
				}

				return this.axios.get( this.race_url + '/' + tab.endpoint )
				.then( response => {
					let data = typeof response.data.data !== 'undefined' ? response.data.data : response.data;

					tab.empty = Object.values( data ).length === 0;

					if ( 'fundraising' === tab.key ) {
						data.fundraising_platform = this.get_fundraising_platform( data );
					}

					this[ tab.key ] = data;
				} )
				.catch( error => {
					this.handle_request_error( error );
					tab.empty = true;
				} );
			},

			// resolves with the race's upsell products, or an empty list if they couldn't be fetched.
			fetch_upsell_products: function() {
				return this.axios.get( 'upsell-products', { params: { race_id: this.$route.params.id } } )
				.then( response => {
					let data = typeof response.data.data !== 'undefined' ? response.data.data : response.data;

					return Object.values( data );
				} )
				.catch( error => {
					this.handle_request_error( error );

					return [];
				} );
			},

			load_upsell_products: function( tab ) {
				// already fetched, nothing to do.
				if ( false !== this.upsell_products ) {
					tab.empty = this.upsell_products.length === 0;

					return Promise.resolve();
				}

				return this.fetch_upsell_products()
				.then( products => {
					this.upsell_products = products;
					tab.empty = products.length === 0;
				} );
			},

			get_fundraising_platform: function( fundraising ) {
				let urls = [ fundraising.fundraising_page_login_url, fundraising.fundraising_page_setup_url ];

				if ( urls.some( url => typeof url === 'string' && url.includes( 'enthuse' ) ) ) {
					return 'enthuse';
				}

				return false;
			},

			is_active_alert: function( id ) {
				return id === this.active_alert;
			},

			alert_dismissed: function( id, state ) {
				this.active_alert = false;

				if ( id === 'withdrawFromRace' && 'confirm' === state ) {
					this.withdraw_from_race();
				}
			},

			withdraw_from_race: function() {
				this.axios.post( 
					'competitor-portal/request-withdrawal',
					{
						'userId': this.$store.getters.user.id,
						'raceId': parseInt( this.$route.params.id ),
					}
				)
				.then( () => {
					this.$store.commit( 'message', { type: 200, text: 'Our race team  have been notified of your withdrawal and will review your request shortly.' } );
				} )
				.catch( error => {
					this.handle_request_error( error, 'Sorry, there has been a problem withdrawing you from this race.' );
				} );
			},

			// the active_tab watcher takes care of loading the tab's data.
			select_tab: function( event ) {
				let tab = this.get_tab( event.target.value );

				if ( typeof tab !== 'undefined' ) {
					this.active_tab = tab.id;
				}
			},

			select_tab_via_button: function( tab ) {
				this.active_tab = tab.id;
			},

			input_checked: function( id ) {
				if ( ! id ) {
					return;
				}

				this.axios.post( this.race_url + '/complete-journey-step/' + id )
				.then( response => {
					let step = this.journey.steps.find( step => response.data.id === step.id );

					if ( typeof step !== 'undefined' ) {
						step.completed_at = response.data.completed_at;
					}
				} )
				.catch( error => {
					this.handle_request_error( error, 'Sorry, there has been a problem updating your to do list.' );
				} );
			}
		}
	}
</script>

<style scoped lang="scss">
	.redacted {
		display: inline-block;
		vertical-align: middle;
		height: 20px;
		background-color: theme( 'colors.mono.darker' );
		width: 80%;
	}

	.fundraising-platform {
		max-width: 125px;
		height: auto;
		margin-bottom: 2rem;
	}

	.pill {
		display: inline-block;
		vertical-align: middle;
		padding-inline: 10px;
		font-weight: 400;
		font-size: 0.833rem;
		margin-bottom: 0.525rem;
		border-radius: 30px;

		&:not([class*="text-"]) {
			color: theme( 'colors.mono.darkest' );
		}

		&:not([class*="bg-"]) {
			background-color: theme( 'colors.advntm.highlight' );

			&.confirmed,
			&.dnf,
			&.added-by-rd,
			&.finisher {	
				background-color: theme( 'colors.state.success' );
			}

			&[class*="failed"],
			&[class*="withdrawn"] {
				background-color: theme( 'colors.state.danger' );
			}
		}
	}

	.upsell {
		background: white;
		height: 100%;
		margin-inline: auto;
		max-width: 375px;
		display: flex;
		flex-direction: column;
	}

	.upsell-btn {
		text-decoration: none;
	}

	.new-pill {
		position: absolute;
		top: 0;
		left: 50%;
		font-size: 12px;
		transform: translateX(-50%) translateY(-66.66%);
	}
</style>